import React from 'react';
import './App.css';
import { BrowserRouter, Redirect, Route,Link,NavLink, Routes, Navigate,
  Outlet} from 'react-router-dom';
import { useNavigate } from 'react-router';
import LitvikLoadingOverlay from './components/LitvikLoadingOverlay';
import Home from "./Home";
import CompanyForm from "./forms/admin/CompanyForm";
import CompanyTable from "./forms/admin/CompanyTable";
import CompanyEdit from "./forms/admin/CompanyForm";
import UnitForm from "./forms/admin/UnitForm";
import UnitTable from "./forms/admin/UnitTable";
import UnitEdit from "./forms/admin/UnitForm";
import Tax from "./forms/admin/Tax";
import TaxEdit from "./forms/admin/TaxEdit";
import Gang from "./forms/admin/Gang";
import GangEdit from "./forms/admin/GangEdit";
import Vendor from "./forms/purchase/Vendor";
import VendorTable from "./forms/purchase/VendorTable";
import VendorEdit from "./forms/purchase/VendorEdit";
import Product from "./forms/admin/Product";
import ProductEdit from "./forms/admin/ProductEdit";
import Permission from "./forms/admin/Permission";
import PermissionEdit from "./forms/admin/PermissionEdit";
import IpAddress from "./forms/admin/IpAddress";
import IpAddressEdit from "./forms/admin/IpAddressEdit";
import User from "./forms/admin/User";
import UserTable from "./forms/admin/UserTable";
import UserEdit from "./forms/admin/UserEdit";
import Login from "./Login";
import { CookiesProvider } from 'react-cookie';
import NumberSetting from "./forms/admin/NumberSetting";
import NumberSettingEdit from "./forms/admin/NumberSettingEdit";
import ApprovalSetting from "./forms/admin/ApprovalSetting";
import ApprovalSettingTable from "./forms/admin/ApprovalSettingTable";
import ApprovalSettingEdit from "./forms/admin/ApprovalSettingEdit";
import CustomerMain from "./forms/marketing/CustomerMain";
import CustomerMainEdit from "./forms/marketing/CustomerMainEdit";
import CustomerSite from "./forms/marketing/CustomerSite";
import CustomerSiteTable from "./forms/marketing/CustomerSiteTable";
import CustomerSiteEdit from "./forms/marketing/CustomerSiteEdit";
import SalesOrder from "./forms/marketing/SalesOrder";
import SalesOrderEdit from "./forms/marketing/SalesOrderEdit";
//import SOApproval from "./SOApproval";
import DesignMix from "./forms/qualitycontrol/DesignMix";
import DesignMixEdit from "./forms/qualitycontrol/DesignMixEdit";
import MoistureCorrection from "./forms/qualitycontrol/MoistureCorrection"
import MoistureCorrectionTable from "./forms/qualitycontrol/MoistureCorrectionTable";
import MoistureCorrectionEdit from "./forms/qualitycontrol/MoistureCorrectionEdit";
import CubeTestReport from "./forms/qualitycontrol/CubeTestReport";
import CubeTestReportEdit from "./forms/qualitycontrol/CubeTestReportEdit";
import CubeTestReportTable from "./forms/qualitycontrol/CubeTestReportTable";
import QcDeliveryChallanReportTable from "./forms/qualitycontrol/QcDeliveryChallanReportTable";
import WorkSchedule from "./forms/Planning/WorkSchedule";
// import So2Schedule from "./So2Schedule";
import WorkScheduleEdit from "./forms/Planning/WorkScheduleEdit";
import JobCompletion from "./forms/Planning/JobCompletion";
 import PumpClearance from "./forms/dispatch/PumpClearance";
// import PumpSchedule from "./PumpSchedule";
import PumpClearanceEdit from "./forms/dispatch/PumpClearanceEdit";
import DeliveryChallan from "./forms/dispatch/DeliveryChallan";
import DeliveryChallanEdit from "./forms/dispatch/DeliveryChallanEdit";
import DeliveryChallanTable from "./forms/dispatch/DeliveryChallanTable";
import CheckIn from "./forms/gate/CheckIn";
import CheckInEdit from "./forms/gate/CheckInEdit";
import CheckInKmCorrection from "./forms/gate/CheckInKmCorrection";
import CheckOut from "./forms/gate/CheckOut";
import CheckOutTable from "./forms/gate/CheckOutTable";
import CheckOutEdit from "./forms/gate/CheckOutEdit";
import VehicleGatePass from "./forms/gate/VehicleGatePass";
import VehicleGatePassTable from "./forms/gate/VehicleGatePassTable";
import VehicleGatePassEdit from "./forms/gate/VehicleGatePassEdit";
import Equipment from "./forms/Transport/Equipment";
import EquipmentEdit from "./forms/Transport/EquipmentEdit";
import DirectInvoice from "./forms/accounts/DirectInvoice";
import DirectInvoiceEdit from "./forms/accounts/DirectInvoiceEdit";
import SalesInvoiceEdit from "./forms/accounts/SalesInvoiceEdit";
import  SalesInvoiceTable from "./forms/accounts/SalesInvoiceTable";
import ReceiptVoucher from "./forms/accounts/ReceiptVoucher";
import ReceiptVoucherEdit from "./forms/accounts/ReceiptVoucherEdit";
import  ReceiptVoucherTable from "./forms/accounts/ReceiptVoucherTable";
import CreditNote from "./forms/accounts/CreditNote";
import CreditNoteEdit from "./forms/accounts/CreditNoteEdit";
import DebitNote from "./forms/accounts/DebitNote";
import DebitNoteEdit from "./forms/accounts/DebitNoteEdit";
import GeneralJournal from "./forms/accounts/GeneralJournal";
import GeneralJournalEdit from "./forms/accounts/GeneralJournalEdit";
import GeneralJournalTable from "./forms/accounts/GeneralJournalTable";
import PurchaseOrder from "./forms/purchase/PurchaseOrder";
import PurchaseOrderEdit from "./forms/purchase/PurchaseOrderEdit";
import PurchaseOrderTable from "./forms/purchase/PurchaseOrderTable";
import PurchaseInvoice from "./forms/purchase/PurchaseInvoice";
import PurchaseInvoiceEdit from "./forms/purchase/PurchaseInvoiceEdit";
import Quotation from "./forms/marketing/Quotation";
import QuotationEdit from "./forms/marketing/QuotationEdit";
import QuotationTable from "./forms/marketing/QuotationTable";
import ConcreteEstimator, { ConcreteEstimatorEdit } from "./forms/marketing/ConcreteEstimator";
import ConcreteEstimatorTable from "./forms/marketing/ConcreteEstimatorTable";
import ConsumptionNote from "./forms/store/ConsumptionNote";
import ConsumptionNoteEdit from "./forms/store/ConsumptionNoteEdit";
import ConsumptionNoteTable from "./forms/store/ConsumptionNoteTable";
import DieselConsumption from "./forms/store/DieselConsumption";
import DieselConsumptionEdit from "./forms/store/DieselConsumptionEdit";
import DieselConsumptionView from "./forms/store/DieselConsumptionView";
import DieselConsumptionTable from "./forms/store/DieselConsumptionTable";
import DailyPlantLog from "./forms/maintenance/DailyPlantLog";
import DailyPlantLogEdit from "./forms/maintenance/DailyPlantLogEdit";
import DailyPlantLogTable from "./forms/maintenance/DailyPlantLogTable";
import MaintenanceMonthlyCost from "./forms/maintenance/MaintenanceMonthlyCost";
import MaintenanceMonthlyCostEdit from "./forms/maintenance/MaintenanceMonthlyCostEdit";
import MaintenanceMonthlyCostTable from "./forms/maintenance/MaintenanceMonthlyCostTable";
import MaintenanceReport from "./forms/maintenance/MaintenanceReport";
import PreventiveMaintenance from "./forms/maintenance/PreventiveMaintenance";
import PreventiveMaintenanceEdit from "./forms/maintenance/PreventiveMaintenanceEdit";
import PreventiveMaintenanceTable from "./forms/maintenance/PreventiveMaintenanceTable";
import CustomerDataReport from "./forms/reports/CustomerDataReport";
import ProductionReport from "./forms/reports/ProductionReport";
import EquipmentReport from "./forms/reports/EquipmentReport";
import GstReport from "./forms/reports/GstReport";
import ReceiptReport from "./forms/reports/ReceiptReport";
import AccountReceivableReport from "./forms/reports/AccountReceivableReport";
import AgeWiseSummary from "./forms/reports/AgeWiseSummary";
import ReportAll from "./forms/reports/ReportAll"; 
import SalesRepForm from './forms/admin/SalesRepForm';
import SalesRepresentativeTable from './forms/admin/SalesRepresentativeTable';
import GroupForm from "./forms/admin/GroupForm";
import GroupFormEdit from "./forms/admin/GroupFormEdit";
import GroupFormTable from "./forms/admin/GroupFormTable";
import Plant from "./forms/admin/Plant";
import PlantEdit from "./forms/admin/PlantEdit";
import PlantTable from "./forms/admin/PlantTable";
import PlantConfigurationTable from "./forms/admin/PlantConfigurationTable";
import PlantConfiguration from "./forms/admin/PlantConfiguration";
import PlantConfigurationEdit from "./forms/admin/PlantConfigurationEdit";
import ProductTable from "./forms/admin/ProductTable";
import PermissionTable from "./forms/admin/PermissionTable";
import CustomerMainTable from "./forms/marketing/CustomerMainTable";
import SalesOrderTable from "./forms/marketing/SalesOrderTable";
import DesignMixTable from "./forms/qualitycontrol/DesignMixTable";
import WorkScheduleTable from "./forms/Planning/WorkScheduleTable";
import PumpClearanceTable from "./forms/dispatch/PumpClearanceTable";
import PurchaseInvoiceTable from "./forms/purchase/PurchaseInvoiceTable";
import CheckInTable from "./forms/gate/CheckInTable";
import EquipmentTable from "./forms/Transport/EquipmentTable";
import BankTable from "./forms/accounts/BankTable";
import CreditNoteTable from "./forms/accounts/CreditNoteTable";
import DebitNoteTable from "./forms/accounts/DebitNoteTable";
import DispatchReport from "./forms/reports/DispatchReport";
import DispatchReportSummary from "./forms/reports/DispatchReportSummary";
import SalesPostingReport from "./forms/reports/SalesPostingReport";
import LedgerAccount from "./forms/reports/LedgerAccount";
import AccountsReceivableAgewise from "./forms/reports/AccountsReceivableAgewise";
import TaxTable from "./forms/admin/TaxTable";
import GangTable from "./forms/admin/GangTable";
import IPAddressTable from "./forms/admin/IPAddressTable";
import NumberSettingTable from "./forms/admin/NumberSettingTable";
import Bank from "./forms/accounts/Bank";
import BankEdit from "./forms/accounts/BankEdit";
import SalesInvoice from "./forms/accounts/SalesInvoice";
import GoodsReceiptNote from "./forms/store/GoodsReceiptNote";
import GoodsReceiptNoteEdit from "./forms/store/GoodsReceiptNoteEdit";
import GoodsReceiptNoteTable from "./forms/store/GoodsReceiptNoteTable";
import AgeWiseReport from "./forms/reports/AgeWiseReport";
import GoodsReceiptNoteReport from "./forms/reports/GoodsReceiptNoteReport";
import DieselStockConsumptionStatement from "./forms/reports/DieselStockConsumptionStatement";
import NotFound from "./NotFound";  
import { useCookies } from 'react-cookie';
import Settings from './forms/admin/Settings';
import RequireAuth from './components/RequireAuth';
import AuthIdleWatcher from './components/AuthIdleWatcher';
import ActivityNotifications from './components/ActivityNotifications';
import { canAccessModule, hasPermission, isSuperuser } from './utils/authSession';

function App() {
  return (
    <BrowserRouter>
      <CookiesProvider>
        <AppRoutes />
      </CookiesProvider>
    </BrowserRouter>
  );
}

function AppRoutes() {
  const [cookies] = useCookies(['myToken']);
  const [category] = useCookies(['myCategory']);
  const [superuser] = useCookies(['mySuperuser']);

  const AdminWrapper = () => (
    canAccessModule(category, superuser, 'is_rmc_admin') ? <Outlet /> : <Navigate to="/Home" />
  );
  const SuperuserOnlyWrapper = () => (
    isSuperuser(superuser) ? <Outlet /> : <Navigate to="/Home" />
  );
  const MarkettingWrapper = () => (
    canAccessModule(category, superuser, 'is_marketting') ? <Outlet /> : <Navigate to="/Home" />
  );
  const QtyCtrlWrapper = () => (
    canAccessModule(category, superuser, 'is_qty_ctrl') ? <Outlet /> : <Navigate to="/Home" />
  );
  const PlanningWrapper = () => (
    canAccessModule(category, superuser, 'is_planning') ? <Outlet /> : <Navigate to="/Home" />
  );
  const DispatchWrapper = () => (
    canAccessModule(category, superuser, 'is_dispatch') ? <Outlet /> : <Navigate to="/Home" />
  );
  const EquipmentWrapper = () => (
    canAccessModule(category, superuser, 'is_transport') ? <Outlet /> : <Navigate to="/Home" />
  );
  const GateWrapper = () => (
    canAccessModule(category, superuser, 'is_gate') ? <Outlet /> : <Navigate to="/Home" />
  );
  const AccountsWrapper = () => (
    canAccessModule(category, superuser, 'is_accounts') ? <Outlet /> : <Navigate to="/Home" />
  );
  const PurchaseWrapper = () => (
    canAccessModule(category, superuser, 'is_purchase') ? <Outlet /> : <Navigate to="/Home" />
  );
  const StoreWrapper = () => (
    canAccessModule(category, superuser, 'is_store') ? <Outlet /> : <Navigate to="/Home" />
  );
  const PurchaseInvoiceWrapper = () => (
    canAccessModule(category, superuser, 'is_purchase')
      || canAccessModule(category, superuser, 'is_store')
      || hasPermission(category, 'add_purchase_invoice')
      || hasPermission(category, 'view_purchase_invoice')
      || hasPermission(category, 'edit_purchase_invoice')
      || hasPermission(category, 'delete_purchase_invoice')
      ? <Outlet /> : <Navigate to="/Home" />
  );
  const MaintenanceWrapper = () => (
    canAccessModule(category, superuser, 'is_maintenance') ? <Outlet /> : <Navigate to="/Home" />
  );
  const UtilityWrapper = () => (
    canAccessModule(category, superuser, 'is_utility')
      || hasPermission(category, 'add_concrete_estimator_master')
      || hasPermission(category, 'view_concrete_estimator_master')
      || hasPermission(category, 'change_concrete_estimator_master')
      || hasPermission(category, 'delete_concrete_estimator_master')
      ? <Outlet /> : <Navigate to="/Home" />
  );
  const ReportWrapper = () => {
    const canViewReports = canAccessModule(category, superuser, 'view_accounts_reports')
      || hasPermission(category, 'view_transport_reports')
      || hasPermission(category, 'view_marketting_reports')
      || hasPermission(category, 'view_dispatch_reports')
      || hasPermission(category, 'view_store_reports');
    return canViewReports ? <Outlet /> : <Navigate to="/Home" />;
  };

  return (
    <>
    <AuthIdleWatcher />
    <LitvikLoadingOverlay />
    <div className="App" id="outer-container">
					   
              <Routes>
                  <Route exact path="/" element={<Login />} />

                  <Route element={<RequireAuth />}>
                  <Route exact path="/Home" element={<Home />} />
                  
                  <Route element={<SuperuserOnlyWrapper />}>
                      <Route path="/Permission" element={<Permission />} />
                      <Route path="/PermissionTable" element={<PermissionTable />} />
                      <Route path="/PermissionEdit/:id"  element={<PermissionEdit />} />
                      <Route path="/IpAddress" element={<IpAddress />} />
                      <Route path="/IPAddressTable" element={<IPAddressTable />} />
                      <Route path="/IpAddressEdit/:id"  element={<IpAddressEdit />} />
                      <Route path="/User" element={<User />} />
                      <Route path="/UserTable" element={<UserTable />} />
                      <Route path="/UserEdit/:id"  element={<UserEdit />} /> 
                  </Route>
                  
                  <Route element={<AdminWrapper />}>
                      <Route path="/Company" element={<CompanyForm/>} /> 
                      <Route path="/CompanyTable" element={<CompanyTable />} />
                      <Route path="/CompanyEdit/:id" element={<CompanyForm />} />
                      <Route path="/Plant" element={<Plant />} />
                      <Route path="/PlantTable" element={<PlantTable />} />
                      <Route path="/PlantEdit/:id"  element={<PlantEdit />} />
                      <Route path="/Unit" element={<UnitForm />} />
                      <Route path="/UnitTable" element={<UnitTable />} />
                      <Route path="/UnitEdit/:id"  element={<UnitForm />} />
                      <Route path="/SalesRep" element={<SalesRepForm />} />
                      <Route path="/SalesRepTable" element={<SalesRepresentativeTable />} />
                      <Route path="/SalesRepEdit/:id"  element={<SalesRepForm />} />
                      <Route path="/Tax" element={<Tax />} />
                      <Route path="/TaxTable" element={<TaxTable />} />
                      <Route path="/TaxEdit/:id"  element={<TaxEdit />} />
                      <Route path="/Gang" element={<Gang />} />
                      <Route path="/GangTable" element={<GangTable />} />
                      <Route path="/GangEdit/:id"  element={<GangEdit />} />
                      <Route path="/Product" element={<Product />} />
                      <Route path="/ProductTable" element={<ProductTable />} />
                      <Route path="/ProductEdit/:id"  element={<ProductEdit />} />
                      <Route path="/NumberSetting" element={<NumberSetting />}/>
                      <Route path="/NumberSettingTable" element={<NumberSettingTable />}/>
                      <Route path="/NumberSettingEdit/:id"  element={<NumberSettingEdit />} />
                      <Route path="/ApprovalSetting" element={<ApprovalSetting />}/>
                      <Route path="/ApprovalSettingTable" element={<ApprovalSettingTable />}/>
                      <Route path="/ApprovalSettingEdit/:id"  element={<ApprovalSettingEdit />} />
                      <Route path="/PlantConfiguration" element={<PlantConfiguration />} />
                      <Route path="/PlantConfigurationTable" element={<PlantConfigurationTable />} />
                      <Route path="/PlantConfigurationEdit/:id"  element={<PlantConfigurationEdit />} />
                  </Route>
                
                  <Route element={<MarkettingWrapper />}>
                      <Route path="/CustomerMain" element={<CustomerMain />} />
                      <Route path="/CustomerMainTable" element={<CustomerMainTable />} />
                      <Route path="/CustomerMainEdit/:id"  element={<CustomerMainEdit />} />
                      <Route path="/CustomerSite" element={<CustomerSite />} />
                      <Route path="/CustomerSiteTable" element={<CustomerSiteTable />} />
                      <Route path="/CustomerSiteEdit/:id"  element={<CustomerSiteEdit />} />
                      <Route path="/Quotation" element={<Quotation />} />
                      <Route path="/QuotationEdit/:id"  element={<QuotationEdit />} />
                      <Route path="/QuotationTable" element={<QuotationTable />} /> 
                      <Route path="/SalesOrder" element={<SalesOrder />} />
                      <Route path="/SalesOrderTable" element={<SalesOrderTable />} />
                      <Route path="/SalesOrderEdit/:id"  element={<SalesOrderEdit />} />
                      {/* <Route path="/SOApproval/:id"  element={<SOApproval />} /> */}
                  </Route>

                  <Route element={<QtyCtrlWrapper />}>
                      <Route path="/DesignMix" element={<DesignMix />} />
                      <Route path="/DesignMixTable" element={<DesignMixTable />} />
                      <Route path="/DesignMixEdit/:id" element={< DesignMixEdit/>} />
                      <Route path = "/MoistureCorrection" element={<MoistureCorrection />}/>
                      <Route path="/MoistureCorrectionTable" element={<MoistureCorrectionTable />} />
                      <Route path="/MoistureCorrectionEdit/:id" element={< MoistureCorrectionEdit/>} />
                      <Route path = "/CubeTestReport" element={<CubeTestReport />}/>
                      <Route path = "/CubeTestReportEdit/:id" element={<CubeTestReportEdit />}/>
                      <Route path="/CubeTestReportTable" element={<CubeTestReportTable />} />
                      <Route path="/QcDeliveryChallanReport" element={<QcDeliveryChallanReportTable />} />
                  </Route>

                  <Route element={<PlanningWrapper />}>
                      <Route path="/WorkSchedule" element={<WorkSchedule />} />
                      <Route path="/WorkScheduleTable" element={<WorkScheduleTable />} />
                      <Route path="/WorkScheduleEdit/:id" element={<WorkScheduleEdit />} />
                      <Route path="/JobCompletion/:id" element={<JobCompletion />} />
                  </Route>

                  <Route element={<DispatchWrapper />}>
                      <Route path="/PumpClearance" element={<PumpClearance />} />
                      <Route path="/PumpClearanceTable" element={<PumpClearanceTable />} />
                      <Route path="/PumpClearanceEdit/:id" element={<PumpClearanceEdit />} />
                      <Route path="/DeliveryChallan" element={<DeliveryChallan />} />
                      <Route path="/DeliveryChallanEdit/:id" element={<DeliveryChallanEdit />} />
                      <Route path="/DeliveryChallanTable" element={<DeliveryChallanTable />} />
                  </Route>

                  <Route element={<EquipmentWrapper />}>
                      <Route path="/Equipment" element={<Equipment />} />
                      <Route path="/EquipmentTable" element={<EquipmentTable />} />
                      <Route path="/EquipmentEdit/:id" element={<EquipmentEdit />} />
                  </Route>

                  <Route element={<PurchaseWrapper />}>
                    <Route path="/Vendor" element={<Vendor />} />
                    <Route path="/VendorTable" element={<VendorTable />} />
                    <Route path="/VendorEdit/:id"  element={<VendorEdit />} />
                    <Route path="/PurchaseOrder" element={<PurchaseOrder />} />
                    <Route path="/PurchaseOrderEdit/:id" element={<PurchaseOrderEdit/>} />
                    <Route path="/PurchaseOrderTable" element={<PurchaseOrderTable/>} />
                  </Route>

                  <Route element={<PurchaseInvoiceWrapper />}>
                    <Route path="/PurchaseInvoice" element={<PurchaseInvoice />} />
                    <Route path="/PurchaseInvoiceEdit/:id"  element={<PurchaseInvoiceEdit />} />
                    <Route path="/PurchaseInvoiceTable" element={<PurchaseInvoiceTable />} />
                  </Route>
                  
                  <Route element={<GateWrapper />}>
                      <Route path="/CheckIn" element={<CheckIn/>} />
                      <Route path="/CheckInTable" element={<CheckInTable/>} />
                      <Route path="/CheckInEdit/:id" element={<CheckInEdit/>} />
                      <Route path="/CheckInKmCorrection" element={<CheckInKmCorrection/>} />
                      <Route path="/CheckOut" element={<CheckOut/>} />
                      <Route path="/CheckOutTable" element={<CheckOutTable/>} />
                      <Route path="/CheckOutEdit/:id" element={<CheckOutEdit/>} />
                      <Route path="/VehicleGatePass" element={<VehicleGatePass/>} />
                      <Route path="/VehicleGatePassEdit/:id" element={<VehicleGatePassEdit/>} />
                      <Route path="/VehicleGatePassTable" element={<VehicleGatePassTable/>} />
                  </Route>
                  
                  <Route element={<AccountsWrapper />}>
                      <Route path="/GroupForm" element={<GroupForm />} />
                      <Route path="/GroupFormEdit/:id" element={<GroupFormEdit />} /> 
                      <Route path="/GroupFormTable" element={<GroupFormTable />} />
                      <Route path="/SalesInvoice" element={<SalesInvoice/>} />
                      <Route path="/SalesInvoiceEdit/:id" element={<SalesInvoiceEdit/>} />
                      <Route path="/SalesInvoiceTable" element={<SalesInvoiceTable/>} /> 
                      <Route path="/Bank" element={<Bank/>} />
                      <Route path="/BankEdit/:id" element={<BankEdit/>} />
                      <Route path="/BankTable" element={<BankTable/>} />
                      <Route path="/ReceiptVoucher" element={<ReceiptVoucher/>} />
                      <Route path="/ReceiptVoucherEdit" element={<ReceiptVoucherEdit/>} />
                      <Route path="/ReceiptVoucherTable" element={<ReceiptVoucherTable/>} />
                      <Route path="/CreditNote" element={<CreditNote/>} />
                      <Route path="/CreditNoteEdit/:id" element={<CreditNoteEdit/>} />
                      <Route path="/CreditNoteTable" element={<CreditNoteTable/>} />
                      <Route path="/DebitNote" element={<DebitNote/>} />
                      <Route path="/DebitNoteEdit/:id" element={<DebitNoteEdit/>} />
                      <Route path="/DebitNoteTable" element={<DebitNoteTable/>} />
                      <Route path="/GeneralJournal" element={<GeneralJournal/>} />
                      <Route path="/GeneralJournal/edit/:id" element={<GeneralJournal/>} />
                      <Route path="/GeneralJournalEdit/:id" element={<GeneralJournalEdit/>} />
                      <Route path="/GeneralJournalTable" element={<GeneralJournalTable/>} />
                      <Route path="/DirectInvoice" element={<DirectInvoice/>} />
                      <Route path="/DirectInvoiceEdit/:id" element={<DirectInvoiceEdit/>} /> 
                  </Route>
                  
                  <Route element={<StoreWrapper />}>
                      <Route path="/GoodsReceiptNote" element={<GoodsReceiptNote />} />
                      <Route path="/GoodsReceiptNoteTable" element={<GoodsReceiptNoteTable />} />
                      <Route path="/GoodsReceiptNoteEdit/:id" element={<GoodsReceiptNoteEdit/>} />
                      <Route path="/ConsumptionNote" element={<ConsumptionNote />} />
                      <Route path="/ConsumptionNoteTable" element={<ConsumptionNoteTable />} />
                      <Route path="/ConsumptionNoteEdit/:id" element={<ConsumptionNoteEdit />} />
                      <Route path="/DieselConsumption" element={<DieselConsumption />} />
                      <Route path="/DieselConsumptionTable" element={<DieselConsumptionTable />} />
                      <Route path="/DieselConsumptionEdit/:id" element={<DieselConsumptionEdit />} />
                      <Route path="/DieselConsumptionView/:id" element={<DieselConsumptionView />} />
                  </Route>

                  <Route element={<UtilityWrapper />}>
                      <Route path="/ConcreteEstimator" element={<ConcreteEstimator />} />
                      <Route path="/ConcreteEstimatorTable" element={<ConcreteEstimatorTable />} />
                      <Route path="/ConcreteEstimatorEdit/:id" element={<ConcreteEstimatorEdit />} />
                  </Route>

                  <Route element={<MaintenanceWrapper />}>
                      <Route path="/DailyPlantLog" element={<DailyPlantLog />} />
                      <Route path="/DailyPlantLogTable" element={<DailyPlantLogTable />} />
                      <Route path="/DailyPlantLogEdit/:id" element={<DailyPlantLogEdit />} />
                      <Route path="/MaintenanceMonthlyCost" element={<MaintenanceMonthlyCost />} />
                      <Route path="/MaintenanceMonthlyCostTable" element={<MaintenanceMonthlyCostTable />} />
                      <Route path="/MaintenanceMonthlyCostEdit/:id" element={<MaintenanceMonthlyCostEdit />} />
                      <Route path="/MaintenanceReport" element={<MaintenanceReport />} />
                      <Route path="/PreventiveMaintenance" element={<PreventiveMaintenance />} />
                      <Route path="/PreventiveMaintenanceTable" element={<PreventiveMaintenanceTable />} />
                      <Route path="/PreventiveMaintenanceEdit/:id" element={<PreventiveMaintenanceEdit />} />
                  </Route>

                  <Route element={<ReportWrapper />}>
                    <Route path="/ReportAll" element={<ReportAll />} />
                  </Route>

                    <Route path="/CustomerDataReport"  element={<CustomerDataReport />} />
                    <Route path="/CubeTestReport"  element={<CubeTestReport />} />
                    <Route path="/ProductionReport"  element={<ProductionReport />} />
                    <Route path="/EquipmentReport"  element={<EquipmentReport />} />
                    <Route path="/GstReport"  element={<GstReport />} />
                    <Route path="/ReceiptReport"  element={<ReceiptReport />} />
                    <Route path="AccountReceivableReport"  element={<AccountReceivableReport />} />
                    <Route path="/AgeWiseSummary"  element={<AgeWiseSummary />} />
                    <Route path="/DispatchReport" element={<DispatchReport />} />
                    <Route path="/DispatchReportSummary" element={<DispatchReportSummary />} />
                    <Route path="/GoodsReceiptNoteReport" element={<GoodsReceiptNoteReport />} />
                    <Route path="/DieselStockConsumptionStatement" element={<DieselStockConsumptionStatement />} />
                    <Route path="/SalesPostingReport" element={<SalesPostingReport />} />
                    <Route path="/AgeWiseReport" element={<AgeWiseReport />} />
                    <Route path="/LedgerAccount" element={<LedgerAccount />} />
                    <Route path="/AccountsReceivableAgewise" element={<AccountsReceivableAgewise />} />
                  {/* only match this when no other routes match */}
                  <Route path ="*" element={<NotFound />} />
                  </Route>
                  </Routes>
                  <Settings/>
                  {cookies?.myToken ? <ActivityNotifications cookies={cookies} /> : null}
    </div>
    </>
  );
}

export default App;
                

